module.exports = __webpack_public_path__ + "static/media/cash-coins-currency_320.2e3905c6.jpg";